import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";
import { keycloakToken, KeycloakToken } from "@youm-front/keycloak/domain";

export class KeycloakAccountSignInRequestDTO extends BaseRequestDTO<KeycloakAccountSignInResponseDTORaw> {
  private static validation = JsonSchemaValidator.compile(
    KeycloakAccountSignInRequestDTO.validationSchema()
  );

  constructor(value: KeycloakAccountSignInResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(
        KeycloakAccountSignInRequestDTO.validation,
        value
      )
    );
  }

  override toJSON(): object {
    return this.value;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["token"],
      properties: {
        token: keycloakToken
      },
      additionalProperties: false
    };
  }
}

interface KeycloakAccountSignInResponseDTORaw {
  token: KeycloakToken;
}
